import * as theme from '../../../../theme';
import logo from '../../../../images/tb-white-main-word-only.png';
import rhLogo from '../../../../images/rh-logo.png';
import maregyOtf from '../../../../theme/MAREGY.otf';
import beautifullyOtf from '../../../../theme/Beautifully.otf';

const dietaryOptions = {
  yes: 'YES - Beneficial to include',
  no: 'NO - Not beneficial',
  small: 'OK in SMALL amounts',
  less: 'Have LESS in diet',
  more: 'Add MORE into diet',
  maintain: 'Maintain what you are doing',
  none: 'Ideally NONE in diet',
  neutral: 'Not helpful or hurtful right now',
  remove: 'Ideally NONE in diet',
};

const rawCookedOptions = {
  both: 'Mix of Raw and Cooked',
  cooked: 'Prioritize cooked foods',
  raw: 'Prioritize raw foods',
};

export function generateWellnessReportHTML(data, fullName, dateStr, brand = 'TruBalance') {

  const formatSectionContent = (sectionKey) => {
    if (sectionKey === 'wellness_pillar_priorities') {
      const priorities = data[sectionKey] || [];
      if (priorities.length === 0) return '';
      const introText = `<p class="intro-text">Out of the categories below to support wellness + weight loss, these are the top 3 that your body sees as most important now.</p>`;
      const listItems = priorities.map((priority, index) => `
        <div class="priority-item">
          <div class="priority-circle">${index + 1}</div>
          <div class="priority-text">${priority}</div>
        </div>
      `).join('');
      return `${introText}<div class="priorities-list">${listItems}</div>`;
    } else if (sectionKey === 'limiting_factors') {
      const factors = data[sectionKey] || [];
      if (factors.length === 0) return '';
      const introText = `<p class="intro-text">Based on the bioenergetic scan, your body indicates these are the factors creating the biggest barrier in reaching your specific wellness + weight loss goals.</p>`;
      const isSugarCleanseYes = data.sugar_cleanse && data.sugar_cleanse.sugar_cleanse && data.sugar_cleanse.sugar_cleanse.toLowerCase() === 'yes';
      const listItems = factors.map((factor, index) => {
        let displayText = factor;
        if (factor.toLowerCase() === 'diet' && isSugarCleanseYes) {
          displayText += ' - Highly consider sugar cleanse';
        }
        return `
          <div class="priority-item">
            <div class="priority-circle">${index + 1}</div>
            <div class="priority-text">${displayText}</div>
          </div>
        `;
      }).join('');
      return `${introText}<div class="priorities-list">${listItems}</div>`;
    } else if (sectionKey === 'foods_to_avoid') {
      const factors = data[sectionKey] || [];
      if (factors.length === 0) return '';
      const headingText = `<p class="heading-text">Ideally Remove for Optimal Wellness:</p>`;
      const items = factors.map((factor, index) => `
        <div class="priority-item">
          <div class="priority-circle">${index + 1}</div>
          <div class="priority-text">${factor}</div>
        </div>
      `);
      const leftItems = items.slice(0, 4).join('');
      const rightItems = items.slice(4).join('');
      return `${headingText}<div class="foods-avoid-container"><div class="priorities-column">${leftItems}</div><div class="priorities-column">${rightItems}</div></div>`;
    } else if (sectionKey === 'hormones') {
      const factors = data[sectionKey] || [];
      if (factors.length === 0) return '';
      const headingText = `<p class="heading-text">Factors Preventing Cortisol Balance:</p>`;
      const listItems = factors.map((factor, index) => `
        <div class="priority-item">
          <div class="priority-circle">${index + 1}</div>
          <div class="priority-text">${factor}</div>
        </div>
      `).join('');
      return `${headingText}<div class="priorities-list">${listItems}</div>`;
    } else if (sectionKey === 'emotional_balance') {
      const eb = data[sectionKey] || {};
      const lb = eb.limiting_beliefs || [];
      const aff = eb.affirmations || [];
      let content = '';
      if (lb.length > 0) {
        content += `
          <p class="heading-text">Limiting Beliefs</p>
          <p class="intro-text">These negative emotional patterns/blocks can limit your wellness even if you are not consciously thinking about them. The imprint remedy will allow your body to process them out.</p>
          <ul>
            ${lb.map(item => `<li>${item}</li>`).join('')}
          </ul>
        `;
      }
      if (aff.length > 0) {
        content += `
          <p class="heading-text">Affirmations</p>
          <p class="intro-text">Consider writing these positive phrases on notecard and hang in a place you see every day.</p>
          <ul>
            ${aff.map(item => `<li>${item}</li>`).join('')}
          </ul>
        `;
      }
      return content;
    } else if (sectionKey === 'movement_and_exercise') {
      const me = data[sectionKey] || {};
      let content = '';

      // Weight Training subsection
      if (me.weight_training && me.weight_training.trim()) {
        const wtLower = me.weight_training.toLowerCase();
        let wtText = '';
        if (wtLower.includes('yes')) {
          wtText = 'YES - Beneficial to include';
        } else if (wtLower.includes('no')) {
          wtText = 'NO - Not beneficial to include right now';
        }
        if (wtText) {
          content += `<p class="heading-text no-bottom">Weight Training</p><p class="content-text">${wtText}</p>`;
          if (wtLower.includes('yes') && me.if_weight_training && me.if_weight_training.trim()) {
            content += `<p class="subheading-text no-bottom">IF WEIGHT TRAINING:</p><p class="content-text">${me.if_weight_training}</p>`;
          }
        }
      }

      // HIIT subsection
      if (me.hiit && me.hiit.recommended && me.hiit.recommended.trim()) {
        const recLower = me.hiit.recommended.toLowerCase();
        let hiitText = '';
        if (recLower.includes('yes')) {
          hiitText = `YES - ${me.hiit.max || ''}`;
        } else if (recLower.includes('no')) {
          hiitText = 'NO - Not beneficial to include right now';
        }
        if (hiitText) {
          content += `<p class="heading-text no-bottom">High Intensity Interval Training (HIIT)</p><p class="content-text">${hiitText}</p>`;
        }
      }

      // Workout Types to Include subsection
      if (me.workout_types && me.workout_types.length > 0) {
        content += `
          <p class="heading-text no-bottom">Workout Types to Include</p>
          <ul class="sub-list">
            ${me.workout_types.map(type => `<li>${type}</li>`).join('')}
          </ul>
        `;
      }

      // Workout Specifics subsection
      let specsContent = '';
      if (me.workout_specifics) {
        const specs = me.workout_specifics;
        if (specs.intensity && specs.intensity.trim()) {
          specsContent += `<p class="content-text">Intensity - ${specs.intensity}</p>`;
        }
        if (specs.duration && specs.duration.trim()) {
          specsContent += `<p class="content-text">Duration - ${specs.duration}</p>`;
        }
        if (specs.frequency && specs.frequency.trim()) {
          specsContent += `<p class="content-text">Frequency - ${specs.frequency}</p>`;
        }
      }
      if (specsContent) {
        content += `<p class="heading-text no-bottom">Workout Specifics</p>${specsContent}`;
      }

      return content;
    } else if (sectionKey === 'nutrition_supports') {
      const ns = data[sectionKey] || {};
      let content = '';

      // Carb Cycling subsection
      if (ns.carb_cycling && ns.carb_cycling.trim()) {
        const ccLower = ns.carb_cycling.toLowerCase();
        let ccText = '';
        if (ccLower.includes('yes')) {
          ccText = 'YES - Beneficial to include';
        } else if (ccLower.includes('no')) {
          ccText = 'NO - Not beneficial right now';
        }
        if (ccText) {
          content += `<p class="heading-text no-bottom">Carb Cycling</p><p class="content-text">${ccText}</p>`;
        }
      }

      // Fasting subsection
      if (ns.fasting && ns.fasting.recommendation && ns.fasting.recommendation.trim()) {
        const recLower = ns.fasting.recommendation.toLowerCase();
        let fastingText = '';
        if (recLower.includes('yes')) {
          fastingText = 'YES - Beneficial to include';
        } else if (recLower.includes('no')) {
          fastingText = 'NO - Not beneficial right now';
        }
        if (fastingText) {
          content += `<p class="heading-text no-bottom">Fasting</p><p class="content-text">${fastingText}</p>`;
          if (recLower.includes('yes')) {
            if (ns.fasting.how_long && ns.fasting.how_long.trim()) {
              content += `<p class="content-text">Fast for ${ns.fasting.how_long}</p>`;
            }
            if (ns.fasting.how_often && ns.fasting.how_often.trim()) {
              content += `<p class="content-text">Fast ${ns.fasting.how_often}</p>`;
            }
          }
        }
      }

      // Blood Sugar Balancing Support subsection
      if (ns.blood_sugar_balancing_support && ns.blood_sugar_balancing_support.length > 0) {
        content += `
          <p class="heading-text no-bottom">Blood Sugar Balancing Support</p>
          <ul class="sub-list">
            ${ns.blood_sugar_balancing_support.map(type => `<li>${type.charAt(0).toUpperCase() + type.slice(1)}</li>`).join('')}
          </ul>
        `;
      }

      // Best Blood Sugar Balancing Supplement subsection
      if (ns.supplement && ns.supplement.trim()) {
        content += `<p class="heading-text no-bottom">Best Blood Sugar Balancing Supplement</p><p class="content-text">${ns.supplement}</p>`;
      }

      return content;
    } else if (sectionKey === 'sugar_cleanse') {
      const sc = data[sectionKey] || {};
      let content = '<p class="intro-text">A sugar cleanse involves removing processed + natural sugars (even fruit in most cases). This is beneficial in fungal/candida imbalances + overall blood sugar re-balancing.</p>';
      const sugarCleanseLower = sc.sugar_cleanse ? sc.sugar_cleanse.toLowerCase() : '';
      let scText = '';
      if (sugarCleanseLower.includes('yes')) {
        scText = 'YES - Needed soon';
      } else if (sugarCleanseLower.includes('no')) {
        scText = 'NO - Not needed right now';
      }
      if (scText) {
        content += `<p class="heading-text no-bottom">Sugar Cleanse</p><p class="content-text">${scText}</p>`;
      }
      if (sugarCleanseLower.includes('yes')) {
        let fruitText = '';
        const fruitLower = sc.fruit ? sc.fruit.toLowerCase() : '';
        if (fruitLower.includes('yes')) {
          fruitText = 'Ok to include some berries';
        } else if (fruitLower.includes('no')) {
          fruitText = 'Do not include berries/fruit';
        }
        const lengthText = `${sc.length || ''} of no sugar - ${fruitText}`;
        content += `<p class="content-text">${lengthText}</p>`;
        content += `<p class="content-text top-margin smaller">This can feel very overwhelming, but the key is less overall sugar, and focusing on blood sugar sustaining foods with more vegetables in the diet. Barbara O'Neil has great resources and videos on this.</p>`;
      }
      return content;
    } else if (sectionKey === 'sleep_support') {
      const ss = data[sectionKey] || {};
      let content = '';

      // Ideal Bedtime
      if (ss.ideal_bedtime && ss.ideal_bedtime.trim()) {
        content += `<p class="heading-text no-bottom">Ideal Bedtime - ${ss.ideal_bedtime}</p>`;
      }

      // Sleep Needed Per Night
      if (ss.sleep_needed_per_night && ss.sleep_needed_per_night.trim()) {
        content += `<p class="heading-text no-bottom">Sleep Needed Per Night - ${ss.sleep_needed_per_night}</p>`;
      }

      // White Noise
      if (ss.white_noise && ss.white_noise.trim()) {
        const wnLower = ss.white_noise.toLowerCase();
        let wnText = '';
        if (wnLower === 'yes') {
          wnText = 'YES - Beneficial to enhance sleep';
        } else if (wnLower === 'neutral') {
          wnText = 'NEUTRAL - Not helpful or hurtful';
        } else if (wnLower === 'no') {
          wnText = 'NO - Not beneficial to include';
        }
        if (wnText) {
          content += `<p class="heading-text no-bottom">White Noise</p><p class="content-text">${wnText}</p>`;
        }
      }

      // Main Imbalance Affecting Sleep
      if (ss.main_imbalance_affecting_sleep && ss.main_imbalance_affecting_sleep.name && ss.main_imbalance_affecting_sleep.name.trim()) {
        const main = ss.main_imbalance_affecting_sleep;
        let mainText = `<i>${main.name}</i>`;
        if (main.description && main.description.trim()) {
          mainText += `<br/><span class="smaller">${main.description}</span>`;
        }
        content += `<p class="heading-text no-bottom">Main Imbalance Affecting Sleep</p><p class="content-text content-margin">${mainText}</p>`;
      }

      // Additional Factors Affecting Sleep
      if (ss.additional_factors_affecting_sleep && ss.additional_factors_affecting_sleep.length > 0) {
        const addFactors = ss.additional_factors_affecting_sleep.map(factor => {
          let factorText = `<i>${factor.name}</i>`;
          if (factor.description && factor.description.trim()) {
            factorText += `<br/><span class="smaller">${factor.description}<span>`;
          }
          return `<p class="content-text content-margin">${factorText}.</p>`;
        }).join('');
        content += `
          <p class="heading-text no-bottom">Additional Factors Affecting Sleep</p>
          ${addFactors}
        `;
      }

      // Restore Peptide
      if (ss.restore_peptide && ss.restore_peptide.trim()) {
        const rpLower = ss.restore_peptide.toLowerCase();
        let rpText = '';
        if (rpLower === 'yes') {
          rpText = 'YES - Beneficial to enhance sleep';
          content += `<p class="heading-text no-bottom">Restore Peptide</p><p class="content-text">${rpText}</p><p class="content-text">I can send info on this</p>`;
        } else if (rpLower === 'no') {
          rpText = 'NO - Not beneficial to include';
          content += `<p class="heading-text no-bottom">Restore Peptide</p><p class="content-text">${rpText}</p>`;
        }
      }

      return content;
    } else if (sectionKey === 'supportive_therapies') {
      const st = data[sectionKey] || {};
      let content = '';

      const therapyMap = {
        cold_plunge: 'Cold Plunge',
        sauna_sessions: 'Sauna Sessions',
        red_light_therapy: 'Red Light Therapy',
        hydrotherapy: 'Hydrotherapy (Hot + Cold Combo)'
      };

      Object.keys(therapyMap).forEach(key => {
        if (st[key] && st[key].trim()) {
          const valueLower = st[key].toLowerCase();
          let therapyText = '';
          if (valueLower.includes('yes')) {
            therapyText = 'YES - Beneficial to include';
          } else if (valueLower.includes('no')) {
            therapyText = 'NO - Not beneficial right now';
          }
          if (therapyText && key === 'hydrotherapy' && valueLower.includes('yes')) {
            therapyText += ' (hot to cold showers)';
          }
          if (therapyText) {
            content += `<p class="heading-text no-bottom">${therapyMap[key]}</p><p class="content-text">${therapyText}</p>`;
          }
        }
      });

      return content;
    } else if (sectionKey === 'dietary_suggestions') {
      const ds = data[sectionKey] || {};
      let content = '';
      const isSugarCleanseYes = data.sugar_cleanse && data.sugar_cleanse.sugar_cleanse && data.sugar_cleanse.sugar_cleanse.toLowerCase() === 'yes';

      // Normalize function
      const normalize = (val) => String(val || '').toLowerCase().trim();

      const formatValue = (val, isRawCooked = false) => {
        const lower = normalize(val);
        const options = isRawCooked ? rawCookedOptions : dietaryOptions;
        return options[lower] || val;
      };

      const dietSections = [
        { heading: 'Animal Protein', key: 'animal_protein' },
        { heading: 'Beans', key: 'beans' },
        { heading: 'Dairy', key: 'dairy' },
        { heading: 'Eggs', key: 'eggs' },
        { heading: 'Fats', key: 'fats' },
        { heading: 'Fish + Seafood', key: 'fish_and_seafood' },
        { heading: 'Fruit', key: 'fruits' },
        { heading: 'Grains', key: 'grains' },
        { heading: 'Gluten', key: 'gluten' },
        { heading: 'Nuts', key: 'nuts' },
        { heading: 'Protein', key: 'protein' },
        { heading: 'Vegetables', key: 'vegetables' },
        { heading: 'Raw Versus Cooked Foods', key: 'raw_vs_cooked_foods' },
      ];

      dietSections.forEach(({ heading, key }) => {
        let sectionContent = '';
        if (key === 'vegetables') {
          let vegText = formatValue(ds.vegetables);
          if (isSugarCleanseYes) {
            vegText += ' - add more during sugar cleanse';
          }
          let corText = formatValue(ds.vegetables_cooked_or_raw, true);
          if (corText) {
            const vcorKey = normalize(ds.vegetables_cooked_or_raw);
            const rvcKey = normalize(ds.raw_vs_cooked_foods);
            if (rvcKey !== 'both' && vcorKey !== rvcKey) {
              let note = '';
              if (rvcKey === 'raw' && vcorKey === 'cooked') {
                note = ', but some raw is fine';
              } else if (rvcKey === 'cooked' && vcorKey === 'raw') {
                note = ', but some cooked is fine';
              }
              corText += note;
            }
            if (corText.includes('foods')) {
              corText = corText.replace('foods', 'vegetables');
            }
          }
          let combined = '';
          if (vegText) {
            combined = vegText + (corText ? '.' : '');
          }
          if (corText) {
            if (combined) combined += ' ' + corText;
            else combined = corText;
          }
          if (combined) {
            sectionContent += `<p class="content-text">${combined}</p>`;
          }
        } else if (key === 'raw_vs_cooked_foods') {
          const rvcText = formatValue(ds.raw_vs_cooked_foods, true);
          if (rvcText) {
            sectionContent += `<p class="content-text">${rvcText}</p>`;
          }
        } else {
          let formatted = formatValue(ds[key]);
          const lowerVal = normalize(ds[key]);
          if (key === 'fats' && !['no', 'none', 'remove'].includes(lowerVal)) {
            formatted += ' - prioritize healthy fats';
          }
          if (key === 'fruits' && isSugarCleanseYes) {
            formatted += ' - remove during sugar cleanse';
          }
          if (key === 'protein') {
            const animalLower = normalize(ds.animal_protein);
            if (animalLower === 'no' && !['no', 'none', 'remove'].includes(lowerVal)) {
              formatted += ' - prioritize plant based';
            }
          }
          if (formatted) {
            sectionContent += `<p class="content-text">${formatted}</p>`;
          }
        }
        if (sectionContent) {
          content += `<p class="heading-text no-bottom">${heading}</p>${sectionContent}`;
        }
      });

      // Add comments if present
      if (ds.comments && ds.comments.trim()) {
        const commentsHtml = ds.comments.replace(/\n/g, '<br/>');
        content += `<p class="heading-text no-bottom">Comments</p><p class="content-text">${commentsHtml}</p>`;
      }

      return content;
    }

    // Placeholder for other sections
    return `<p>Content for ${sectionKey} goes here.</p>`;
  };

  const fontUrl = 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap';
  const importRule = `@import url('${fontUrl}');`;

  const fontFaceRule = `
    @font-face {
      font-family: 'Maregy';
      src: url('${maregyOtf}') format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  const fontFaceBeautifully = `
    @font-face {
      font-family: 'Beautifully';
      src: url('${beautifullyOtf}') format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  // Brand-specific toggles
  const logoSrc = brand === 'TruBalance' ? logo : rhLogo;
  const purpleColor = brand === 'TruBalance' ? theme.Colors.Purple : theme.Colors.RHPurple;
  const grayDark = brand === 'TruBalance' ? theme.Colors.GrayDark : theme.Colors.RHBlack;
  const grayLight = brand === 'TruBalance' ? theme.Colors.GrayLightStandard : theme.Colors.RHPurpleLight;
  const logoMaxHeight = brand === 'TruBalance' ? '32px' : '46px';
  const logoTop = brand === 'TruBalance' ? '78px' : '72px';
  const logoTopPrint = brand === 'TruBalance' ? '83px' : '77px';
  const logoMaxHeightPrint = brand === 'TruBalance' ? '26px' : '37px';

  // Define sections for left and right columns
  const leftSections = [
    { title: 'Wellness Pillar Priorities', key: 'wellness_pillar_priorities' },
    { title: 'Emotional Balance', key: 'emotional_balance' },
    { title: 'Movement and Exercise', key: 'movement_and_exercise' },
    { title: 'Nutrition Supports', key: 'nutrition_supports' },
    { title: 'Sugar Cleanse', key: 'sugar_cleanse' },
    { title: 'Foods to Avoid', key: 'foods_to_avoid' },
    { title: 'Hormones', key: 'hormones' },
  ];

  const leftSectionsFirst = leftSections.slice(0, 3);
  const leftSectionsSecond = leftSections.slice(3);

  const rightSections = [
    { title: 'Limiting Factors', key: 'limiting_factors' },
    { title: 'Sleep Support', key: 'sleep_support' },
    { title: 'Supportive Therapies', key: 'supportive_therapies' },
    { title: 'Dietary Suggestions', key: 'dietary_suggestions' },
  ];

  const rightSectionsFirst = rightSections.slice(0, 3);
  const rightSectionsSecond = rightSections.slice(3);

  // Generate HTML for sections in a column
  const generateColumnHTML = (sections) => {
    return sections.map(({ title, key }) => {
      const content = formatSectionContent(key);
      if (content.trim() === '') return '';
      return `
        <div class="section">
          <div class="gray-bar">${title}</div>
          <div class="section-content">
            ${content}
          </div>
        </div>
      `;
    }).join('');
  };

  const leftColumnHTMLFirst = generateColumnHTML(leftSectionsFirst);
  const leftColumnHTMLSecond = generateColumnHTML(leftSectionsSecond);
  const rightColumnHTMLFirst = generateColumnHTML(rightSectionsFirst);
  const rightColumnHTMLSecond = generateColumnHTML(rightSectionsSecond);

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Wellness Report</title>
      <style>
        ${importRule}
        ${fontFaceRule}
        ${fontFaceBeautifully}
        body { font-family: Montserrat, Arial, sans-serif; background: white; margin: 0; padding: 0; }
        .container { max-width: 800px; margin: 0 auto; padding: 10px; display: flex; justify-content: space-between; }
        .column { width: 48%; }
        .left-column { padding-right: 25px; padding-left: 20px; }
        .right-column { padding-left: 25px; padding-right: 20px; }
        .header-bar { background-color: ${grayDark}; height: auto; width: 100%; display: flex; justify-content: center; align-items: center; padding: 20px; box-sizing: border-box; }
        .second-header-bar { display: none; }
        .header-container { display: flex; justify-content: space-between; align-items: center; max-width: 800px; width: 100%; height: 110px; position: relative; }
        .header-left { flex: 2; display: flex; flex-direction: column; align-items: flex-start; }
        .header-title { font-family: Beautifully, Montserrat, Arial; font-size: 100px; color: white; position: absolute; top: -10px; left: 10px; }
        .logo { max-height: ${logoMaxHeight}; position: absolute; top: ${logoTop}; left: 125px; }
        .header-right { flex: 1; display: flex; flex-direction: column; align-items: flex-end; color: white; font-size: 16px; }
        .header-detail-container { margin-top: 15px; text-transform: uppercase; display: flex; flex-direction: row; width: 100%; justify-content: space-between; }
        .header-detail-left { flex: 0.75 }
        .header-detail-right { flex: 2; }
        .gray-bar { font-family: Beautifully, Montserrate, Arial; background-color: ${grayLight}; box-sizing: border-box; font-size: 50px; height: 50px; width: 100%; display: flex; align-items: center; padding-left: 12px; color: black; margin-top: 20px; }
        .section-content { padding: 10px; padding-top: 0px; }
        h1 { font-family: 'Maregy'; font-size: 24px; font-weight: bold; text-transform: uppercase; margin-bottom: 10px; letter-spacing: 2px }
        p { font-size: 16px; line-height: 1.3; margin-bottom: 10px; }
        h3 { font-size: 16px; margin-bottom: 5px; }
        ul { padding-left: 10px; list-style-type: disc; margin-left: 10px; margin-bottom: 0px; }
        li { margin-bottom: 6px; font-size: 14px; }
        .print-btn { position: absolute; top: 20px; right: 20px; padding: 8px 16px; background: ${purpleColor}; border-radius: 4px; color: white; border: none; cursor: pointer; }
        .print-btn:hover { background: ${theme.Colors.GoldDark}; }
        .intro-text { font-size: 12px; font-style: italic; margin-bottom: 15px; text-align: justify; }
        .priorities-list { display: flex; flex-direction: column; gap: 10px; }
        .priority-item { display: flex; align-items: center; gap: 10px; }
        .priority-circle { color: ${purpleColor}; width: 25px; height: 25px; border-radius: 50%; border: 4px double ${purpleColor}; display: flex; justify-content: center; align-items: center; font-size: 15px; flex-shrink: 0; }
        .priority-text { text-transform: uppercase; font-size: 14px; }
        .foods-avoid-container { display: flex; justify-content: space-between; gap: 20px; }
        .priorities-column { display: flex; flex-direction: column; gap: 10px; width: 45%; }
        .heading-text { text-transform: uppercase; font-weight: bold; font-size: 14px; }
        .subheading-text { text-transform: uppercase; font-style: italic; font-size: 14px; }
        .content-text { padding: 0px; margin: 0px; font-size: 14px; }
        .sub-list { margin-top: 3px; padding-top: 0px; }
        .no-bottom { margin-bottom: 0px; padding-bottom: 0px; }
        .top-margin { margin-top: 15px }
        .content-margin { margin-top: 6px; margin-bottom: 8px; }
        .smaller { font-size: 12px;}
        .additional { margin-top: 50px }
        @media print { 
          .print-btn { display: none; } 
          @page { margin: 0; size: letter portrait; }
          body { margin: 0; padding: 0; display: flex; flex-direction: column; height: 100%; }
          .container { max-width: 100%; height: auto; flex: 1; display: flex; flex-direction: row; box-sizing: border-box; justify-content: space-between; padding: 10px 20px; }
          .column { width: 48%; }
          .left-column { padding-right: 25px; }
          .right-column { padding-left: 5px; }
          .header-bar { justify-content: space-between; padding: 15px 10px; flex-shrink: 0; page-break-after: avoid; }
          .second-header-bar { background-color: ${grayDark}; height: 98px; width: 100%; align-items: center; padding: 20px; box-sizing: border-box; display: flex; justify-content: space-between; padding: 15px 10px; flex-shrink: 0; page-break-before: always; page-break-after: avoid; }
          .header-container { max-width: 100% }
          .header-title { font-size: 82px; left: 50px; top: 8px; }
          .header-detail-left { flex: 0.6 }
          .logo { max-height: ${logoMaxHeightPrint}; top: ${logoTopPrint}; left: 145px; }
          .header-right { font-size: 12px; }
          .gray-bar { page-break-inside: avoid; font-size: 42px; height: 40px; margin-top: 10px; }
          .section-content { page-break-inside: avoid; }
          p { font-size: 12px; }
          h3 { font-size: 12px; }
          li { font-size: 11px; }
          .intro-text { font-size: 9.7px; line-height: 1.1 }
          .priority-text { font-size: 11px; }
          .priority-circle { width: 22px; height: 22px; border: 3px double ${purpleColor}; font-size: 10px; }
          .foods-avoid-container { display: flex; justify-content: space-between; gap: 15px; }
          .priorities-column { display: flex; flex-direction: column; gap: 8px; width: 45%; }
          .heading-text { font-size: 12px; }
          .subheading-text { font-size: 12px; }
          .content-text { font-size: 12px; }
          .smaller { font-size: 10px; }
          .additional { padding-left: 10px; padding-right: 25px; }
          * { box-sizing: border-box; orphans: 1; widows: 1; }
        }
      </style>
    </head>
    <body>
      <div class="header-bar">
        <div class="header-container">
          <div class="header-left">
            <div class="header-title">Wellness Scan</div>
            <img src="${logoSrc}" alt="Logo" class="logo">
          </div>
          <div class="header-right">
            <div class="header-detail-container"><div class="header-detail-left">Name&nbsp;&nbsp;|</div><div class="header-detail-right">${fullName}</div></div>
            <div class="header-detail-container"><div class="header-detail-left">Date&nbsp;&nbsp;|</div><div class="header-detail-right">${dateStr}</div></div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="column left-column">
          ${leftColumnHTMLFirst}
        </div>
        <div class="column right-column">
          ${rightColumnHTMLFirst}
        </div>
      </div>
      <div class="second-header-bar">
        <div class="header-container">
          <div class="header-left">
            <div class="header-title">Nutrition Guide</div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="column left-column">
          ${leftColumnHTMLSecond}
        </div>
        <div class="column right-column">
          ${rightColumnHTMLSecond}
          <div class="additional">
            <p class="heading-text no-bottom">Important Note + Disclaimer</p>
            <p class="intro-text content-margin">These suggestions are based on your bioenergetic scan. Your practitioner may advise differently based on your specific needs + goals. But these can be used as a general guideline for what your body is looking for right now.</p>
            <p class="intro-text content-margin">Statements made in this document are not intended to diagnose, treat, cure, or prevent any disease. This information is not intended to replace the advice of your medical doctor. Please consult you medical provider for any medical or health related concerns.</p>
          </div>
        </div>
      </div>
      <button class="print-btn" onclick="window.print()">Print</button>
    </body>
    </html>
  `;
}